var view = require('./addressPostcodeSearchView');
var ajaxWrapper = require('./ajaxWrapper');

function hasChild(html) {
    "use strict";
    return $(html).children().size() > 0;
}

function searchAddresses(postcode) {
    "use strict";
    ajaxWrapper.call({
        dataType: "html",
        url: "/ajax-calls/addresses/search?postcode=" + postcode,
        success: function (addresses) {
            view.hidePostcodeSearchErrorMsg();
            view.hideUnrecognisedPostcodeErrorMsg();

            if (hasChild(addresses)) {
                view.hideEnterAddressManuallyLink();
                view.hidePostcodeSearchNoResultsError();
            } else {
                view.showEnterAddressManuallyLink();
                view.showPostcodeSearchNoResultsError();
            }
            view.showAddressesList(addresses);
            view.removeSpinnerForFindAddress();
        },
        failure: function (error) {
            view.removeSpinnerForFindAddress();
            view.showEnterAddressManuallyLink();

            if (error.status === 400) {
                view.showUnrecognisedPostcodeErrorMsg();
            }
            else {
                view.showPostcodeSearchErrorMsg();
            }
        }
    });
}

function postcodeSearchOnEnterKeyEvent(e) {
    "use strict";
    return ((e.keyCode || e.which) === 13) ? whenPostcodeSearchRequested() : true;
}

function whenPostcodeSearchRequested() {
    "use strict";
    view.validatePostcodeInput();

    if (view.isPostcodeValueInAValidFormat()) {
        view.addSpinnerOnFindAddressButton();
        searchAddresses(view.getPostcodeSearchValue());
    }

    return false;
}

function initialize() {
    "use strict";
    view.whenEnterKeyPressedInPostcodeSearch(postcodeSearchOnEnterKeyEvent);
    view.whenPostCodeSearch(whenPostcodeSearchRequested);
}

module.exports = {
    initialize: initialize
};
